import {useMutation} from "@tanstack/react-query";
import {submitCustomerOfferMutationOptions} from "./submit-customer-offer.mutation-options";

export function useSubmitCustomerOffer() {
  return useMutation(submitCustomerOfferMutationOptions());
}
